import React from 'react';
import { useSelector } from 'react-redux';
import Divider from 'housecall-ui/dist/DesignSystem/DataDisplay/Divider/Divider';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import ExpansionPanel from 'housecall-ui/dist/DesignSystem/Surfaces/ExpansionPanels/ExpansionPanel';
import ExpansionPanelDetails from 'housecall-ui/dist/DesignSystem/Surfaces/ExpansionPanels/ExpansionPanelDetails';
import ExpansionPanelSummary from 'housecall-ui/dist/DesignSystem/Surfaces/ExpansionPanels/ExpansionPanelSummary';
import ExpandMoreIcon from 'housecall-ui/dist/IconsAndImages/Icons/ExpandMore';
import { isPresent } from 'utils/isPresent';

import TaskContent from 'components/Toolbar/Tasks/TaskContent';

import { getCompletedTasksList } from './TasksData';

const useStyles = makeStyles(() => ({
  expansionDetailsStyle: { padding: 0, display: 'inherit' },
}));

const CompletedTasks = () => {
  const completedTasks = useSelector(getCompletedTasksList);
  const { expansionDetailsStyle } = useStyles();

  if (isPresent(completedTasks)) {
    return (
      <ExpansionPanel data-testid="completed-tasks-container">
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1">Completed</Typography>
        </ExpansionPanelSummary>

        <ExpansionPanelDetails className={expansionDetailsStyle}>
          <Divider />
          <TaskContent tasks={completedTasks} header="" />
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
  return null;
};

export default CompletedTasks;
